import { useQuery } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface UserPaymentMethodData {
  paymentMethods: PaymentMethod[];
}

type PaymentMethod = {
  id: string;
  brand: string;
  last4: string;
  exp_month: number;
  exp_year: number;
  default: boolean;
};

export function useUserPaymentMethods() {
  const { keycloak } = useKeycloak();

  return useQuery({
    queryKey: ['userPaymentMethods'],
    queryFn: async (): Promise<UserPaymentMethodData> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_USER_ENGINE_ENDPOINT
        }/api/v1/bundles/user_bundle/functions/get_payment_methods`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'GET',
        }
      );

      let data = await response.json();

      return data?.data;
    }
  });
}
